// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1O8Mp","file":"styles_file__2znMS"};